/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useHistory, useLocation } from 'react-router-dom';
import { IFilter } from '../../../interfaces';
import { useDispatch, useSelector } from 'react-redux';

import LayoutInside from '../../layout/LayoutInside';
import { fetchListRegions, resetRegion } from '../../../../modules/sport/actions/reducerListRegion';
import { getCommuneByRegions } from '../../../../modules/sport/actions/reducerListCommune';
import SuccessCard from '../../sections/SuccessCard';
import DesafiaIconsFutbol from '../../../components/images/sports/futbol/icons/desafia2@2x.png';

export default function FilterDefy(props: { attribute: any; dateList: any }): JSX.Element {
    const { attribute } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [communes, setCommune] = useState<Array<any>>([]);
    const errorInit = { region: false, commune: false };
    const [error, setError] = useState(errorInit);
    const [msj, setMsj] = useState('');
    const router = useHistory();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const attributeUrl = pathname.length > 1 ? pathname[2] : 'Arrienda';
    const [regions, setRegions] = useState<Array<any>>([]);
    const breads = [
        {
            key: 'sport',
            name: 'Equipos | Buscar',
            url: `/desafiar`,
            add: true,
        },
    ];

    const [filter, setFilter] = useState<IFilter>({
        day: null,
        region: '',
        commune: '',
        club: '',
        onlyAvailable: '',
    });
    const dispatch = useDispatch();

    const selectListRegions = (state: any) => state.listRegions;
    const listRegions = useSelector(selectListRegions);

    const selectListCommunes = (state: any) => state.listCommunes;
    const listCommunes = useSelector(selectListCommunes);

    useEffect(() => {
        dispatch(fetchListRegions({ filter: 1, sport: sport, type: 'challenge' }));
    }, []);

    useEffect(() => {
        if (listRegions.data && listRegions.data.length > 0) {
            setRegions(listRegions.data);
        }
    }, [listRegions]);

    useEffect(() => {
        if (listCommunes && listCommunes.data?.data?.length > 0) {
            setCommune(listCommunes.data?.data);
        } else {
            setCommune([]);
        }
    }, [listCommunes]);

    useEffect(() => {
        setRegions([]);
        setCommune([]);
        dispatch(resetRegion());
        dispatch(fetchListRegions({ filter: 1, sport: sport, type: 'challenge' }));
    }, [sport]);

    const handleRegion = async (e) => {
        e.preventDefault();
        setLoading(true);
        // setRegion(e.target.value);
        setFilter({ ...filter, region: e.target.value });
        dispatch(getCommuneByRegions({ id: e.target.value, sport: sport, filter: 1, type: 'challenge' }));
        setLoading(false);
    };

    const handleCommune = (e) => {
        e.preventDefault();
        setFilter({ ...filter, commune: e.target.value });
    };

    const handleNext = () => {
        setError(errorInit);
        if (filter.region === '') {
            setError({ ...error, region: true });
        } else {
            setMsj('Valido');
            const path = `/${sport}/${attributeUrl}/equipos/filter`;
            if (path) {
                const search = `?region=${filter.region ? filter.region : ''}&commune=${
                    filter.commune && filter.commune !== undefined ? filter.commune : ''
                }&week=&limit=15&page=1&onlyAvailable=${filter.onlyAvailable}`;
                router.push({
                    pathname: path,
                    search: search,
                });
            }
        }
    };

    return (
        <>
            <LayoutInside
                attribute={{
                    ...attribute,
                    subTitle: null,
                    icon:
                        sport === 'futbol'
                            ? {
                                  image: DesafiaIconsFutbol,
                                  class: 'pl-14',
                              }
                            : attribute.icon,
                }}
                title={null}
                subTitle={''}
                breads={breads}
            >
                <>
                    {sport === 'futbol' && (
                        <SuccessCard>
                            <div className="py-12">
                                <p className=" text-center text-2xl font-bold italic">LIGA LIBRE 7X7 SUPERMATCH</p>
                                <p className=" text-center text-2xl font-bold italic">¡ BIENVENIDO AL JUEGO !</p>
                                <p className="">_________________________</p>
                                <div className="pt-2 px-6 text-xl font-semibold italic  flex align-center text-left">
                                    <ul className="list-['-_'] list-outside">
                                        <li>Inscripción gratuita.</li>
                                        <li>Paga sólo el partido juegas.</li>
                                        <li>Tú eliges cuándo jugar.</li>
                                        <li>Todos los partidos disputan puntos de FASE REGULAR.</li>
                                        <li>
                                            Clasifican 8 equipos por comuna a POST TEMPORADA (Play Off): 4 con más Pts,
                                            2 con más % de rendimiento y 2 con más Partidos Jugados.
                                        </li>
                                        <li>
                                            El campeón y subcampeón de los play off representará a su comuna en el
                                            TORNEO DE CAMPEONES INTER COMUNAL.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </SuccessCard>
                    )}
                    <p className="text-center text-xl font-bold italic text-sm-blue-primary pt-10">
                        ¿Dónde quieres jugar?
                    </p>
                    {/** Filter */}
                    <div className={`flex-col pt-2 md:pt-10`}>
                        <div className="container snap-mandatory snap-y  mx-auto w-full flex justify-center items-center">
                            <div
                                className={`grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 text-center justify-center items-center`}
                            >
                                <div className="flex-col flex justify-end  items-end p-2 md:px-4">
                                    <div className="flex w-full md:w-60 lg:w-60 h-14 justify-center content-center">
                                        <select
                                            className={`${
                                                error.region
                                                    ? 'border-red-600 shadow-error'
                                                    : filter.region
                                                    ? 'border-green-600 shadow-success'
                                                    : 'border-sm-gray-3'
                                            } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                            name="region"
                                            onChange={handleRegion}
                                            disabled={regions && regions.length > 0 ? false : true}
                                        >
                                            <option className="text-sm-gray-1" value="">
                                                Región *
                                            </option>
                                            {regions &&
                                                regions.length > 0 &&
                                                regions.map((r, i) => (
                                                    <option value={r.id} key={`region-${i}`}>
                                                        {r.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="flex-col  flex justify-start  items-start p-2 md:px-4 ">
                                    <div className="flex w-full md:w-60 h-14 justify-center content-center ">
                                        {!loading ? (
                                            <select
                                                className={`${
                                                    error.commune
                                                        ? 'border-red-600 shadow-error'
                                                        : filter.commune
                                                        ? 'border-green-600 shadow-success'
                                                        : 'border-sm-gray-3'
                                                } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                                name="commune"
                                                onChange={handleCommune}
                                                disabled={communes && communes.length > 0 ? false : true}
                                            >
                                                <option className="text-sm-gray-1" value="">
                                                    Comuna
                                                </option>
                                                {communes &&
                                                    communes.length > 0 &&
                                                    communes.map((commune) => (
                                                        <option value={commune.id} key={`commune-${commune.id}`}>
                                                            {commune.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        ) : (
                                            <div className="border border-sm-rent shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                                <div className="animate-pulse flex space-x-4">
                                                    <div className="rounded-full bg-sm-rent-dark h-6 w-12"></div>
                                                    <p className="pl-1 animate-pulse text-sm-rent-dark">Comuna</p>
                                                    <div className="flex-1 space-y-4 py-1">
                                                        <div className="h-4 bg-sm-rent-dark rounded w-3/4"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/**Button Next */}
                        <div className={`flex-col snap-center`}>
                            <div className={`pt-2 md:pt-16 pb-20 text-center`}>
                                <button
                                    className={`${attribute.filter.btColor} w-1/2 md:w-1/4 lg:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                    type="button"
                                    onClick={() => handleNext()}
                                >
                                    {attribute.filter.btName}
                                </button>
                                <p className={`text-sm-rent-dark text-xs uppercase py-4 font-extrabold`}>{msj}</p>
                            </div>
                        </div>
                    </div>
                </>
            </LayoutInside>
        </>
    );
}
